import styles from './ProjectChart.module.scss'
import {DrawdownsChart, ScheduleChart} from '.'

interface ProjectChartProps {
  project: any
}

export default function ProjectChart({project}: ProjectChartProps) {
  return (
    <div className={styles.root}>
      <ScheduleChart noLabel project={project} size={300} />
      <DrawdownsChart className={styles.inner} project={project} size={200} />
    </div>
  )
}
